module.exports = __webpack_public_path__ + "static/media/challenge_arrow.f314acf5.png";